// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  useEmulators: false,
  firebase: {
    apiKey: 'AIzaSyD1GAmXPBoJKRXJF_Z_7nR7qiCcZaRPf5Y',
    authDomain: 'uvema-app-2b330.firebaseapp.com',
    databaseURL: 'https://uvema-app-2b330-default-rtdb.firebaseio.com',
    projectId: 'uvema-app-2b330',
    storageBucket: 'uvema-app-2b330.appspot.com',
    messagingSenderId: '659064338561',
    appId: '1:659064338561:web:689299a235671c6157f580',
    measurementId: 'G-HVPYC29CZX',
  },
  emulators: {
    auth: { host: 'http://localhost:9099' },
    database: { host: 'localhost', port: 9000 },
    functions: { host: 'localhost', port: 5001 },
    storage: { host: 'localhost', port: 9199 },
  },
  sentry: {
    dsn: 'https://dd4b5ddef5ec75c8886533fcd5adbf24@sentry.bokokode.io/44',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error'; // Included with Angular CLI.
